import React from 'react';
import open from '../../assets/open.svg';

/* eslint-disable react/prop-types */
const OpenFile = () => <img src={open} alt="Åpne ny fane" />;

export default OpenFile;
